(function () {
  if (window.__ctPlpFiltersBound) return;
  window.__ctPlpFiltersBound = true;

  // Kept as no-op for any legacy inline handlers.
  window.handleStoreInput = function () {};

  function buildPaginationSkeletonHtml(count) {
    var total = Math.max(4, Number(count) || 6);
    var html = '';
    for (var i = 0; i < total; i += 1) {
      html +=
        '<article class="CT_product-block product-block k-custom-product-skeleton ct-page-load-skeleton" aria-hidden="true">' +
          '<div class="block-inner">' +
            '<div class="block-inner-inner">' +
              '<div class="k-custom-sk-media k-custom-sk-shimmer"></div>' +
              '<div class="product-info">' +
                '<div class="k-custom-sk-line k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-line k-custom-sk-line--short k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-price-row">' +
                  '<span class="k-custom-sk-price k-custom-sk-shimmer"></span>' +
                  '<span class="k-custom-sk-offer k-custom-sk-shimmer"></span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</article>';
    }
    return html;
  }

  function showPaginationSkeleton(container) {
    if (!container || container.querySelector('.ct-page-load-skeleton')) return;
    container.insertAdjacentHTML('beforeend', buildPaginationSkeletonHtml(6));
  }

  function hidePaginationSkeleton(container) {
    if (!container) return;
    var nodes = container.querySelectorAll('.ct-page-load-skeleton');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i] && nodes[i].parentNode) {
        nodes[i].parentNode.removeChild(nodes[i]);
      }
    }
  }

  function patchAjaxinatePaginationSkeleton() {
    if (window.__ctAjaxinateSkeletonPatched) return;
    if (typeof Ajaxinate !== 'function' || !Ajaxinate.prototype || typeof Ajaxinate.prototype.loadMore !== 'function') return;
    window.__ctAjaxinateSkeletonPatched = true;

    var originalLoadMore = Ajaxinate.prototype.loadMore;

    Ajaxinate.prototype.loadMore = function () {
      var container = this && this.containerElement ? this.containerElement : null;
      var shouldHandle = !!(container && container.id === 'infinite-scroll-loop');
      var self = this;
      var cleanupTimer = null;
      var originalCallback = this && this.settings ? this.settings.callback : null;

      function cleanup() {
        if (cleanupTimer) {
          window.clearTimeout(cleanupTimer);
          cleanupTimer = null;
        }
        hidePaginationSkeleton(container);
        if (self && self.settings) {
          self.settings.callback = originalCallback;
        }
      }

      if (shouldHandle) {
        showPaginationSkeleton(container);
        cleanupTimer = window.setTimeout(cleanup, 12000);
        if (self && self.settings) {
          self.settings.callback = function (responseXML) {
            cleanup();
            if (typeof originalCallback === 'function') {
              originalCallback(responseXML);
            }
          };
        }
      }

      try {
        return originalLoadMore.apply(this, arguments);
      } catch (error) {
        cleanup();
        throw error;
      }
    };
  }

  patchAjaxinatePaginationSkeleton();

  document.addEventListener('DOMContentLoaded', function () {
    patchAjaxinatePaginationSkeleton();
    new Ajaxinate({
      container: '#infinite-scroll-loop',
      pagination: '#infinite-scroll-pagination',
      loadingText:
        '<center><img src="//cdn.shopify.com/s/files/1/0796/1959/files/loading.gif?v=1652268937" loading="lazy"></center>',
    });
  });

  if (window.jQuery) {
    $(document).ready(function () {
      $(document).ajaxComplete(function (event, xhr, settings) {
        $('.ct_filter_apply').addClass('active');
        if (settings.url.includes('collections')) {
          if (window.__ctMobileFilterApplyPendingClose && $(window).width() < 760) {
            window.__ctMobileFilterApplyPendingClose = false;
            $('.filters__close').trigger('click');
          }
          new Ajaxinate({
            container: '#infinite-scroll-loop',
            pagination: '#infinite-scroll-pagination',
            loadingText:
              '<center><img src="//cdn.shopify.com/s/files/1/0796/1959/files/loading.gif?v=1652268937" loading="lazy"></center>',
          });
          jQuery('.CT_link-dropdown__button').click(function () {
            if (jQuery('.ct_fil_shade').hasClass('ct_fill_active')) {
              jQuery('.ct_fil_shade').removeClass('ct_fill_active');
              jQuery('#shopify-section-header').removeClass('ct_active_sort');
              jQuery('.template-collection').removeClass('ct_active_sort_body');
            } else {
              jQuery('.ct_fil_shade').addClass('ct_fill_active');
              jQuery('#shopify-section-header').addClass('ct_active_sort');
              jQuery('.template-collection').addClass('ct_active_sort_body');
            }
          });
        }
        const resultUrl = window.AF_SMART_SCRIPT_RESULT?.clickURL || null;
        if (typeof window.setHrefForElements === 'function') {
          setHrefForElements(resultUrl);
        }
      });

      jQuery(document).on('click', '.ct-march_discount_fliter .ct-march_discount_fliter_main .ct_selected', function (e) {
        e.preventDefault();
        const c_value = jQuery(this).attr('data-value');
        const applyBtn = jQuery('button.apply_btn.ct_submit_sec.btn');

        jQuery('#CollectionFilterForm .ct_Discounts .filter-group__item .filter-group__checkbox').each(function () {
          if (jQuery(this).val() == c_value) {
            jQuery(this).trigger('click');
          }
        });

        if (applyBtn.prop('disabled')) {
          applyBtn.prop('disabled', false);
        }
        applyBtn.trigger('click');
      });

    });

    if ($(window).width() < 760) {
      $(document).on('click', '.filter-footer-btn-main .ct_submit_sec', function () {
        window.__ctMobileFilterApplyPendingClose = true;
      });
      $(document).on('click', '.filter-footer-btn-main .filter-group__clear-link', function () {
        $('.filters__close').trigger('click');
      });
    }

    $(document).on(
      'change',
      '#CollectionFilterForm .filter-group__item input, #CollectionFilterForm .cc-price-range__input, .collection-filter-form .filter-group__item input, .collection-filter-form .cc-price-range__input',
      function () {
        const $form = $(this).closest('form');
        $form.find('.apply_btn.ct_submit_sec, .apply_btn.ct_submit').removeAttr('disabled');
      }
    );

    $(document).on('click', '#CollectionFilterForm .ct_Category label .filter-group__checkbox', function () {
      const $form = $(this).closest('#CollectionFilterForm');
      $form.find('.apply_btn.ct_submit_sec').removeAttr('disabled');

      if (!$(this).prop('checked')) {
        const len_check = jQuery(
          "#CollectionFilterForm .ct_Category .toggle-target-container .filter-group__item input[type='checkbox']:checked"
        ).length;

        if (len_check < 1) {
          jQuery(
            "#CollectionFilterForm .ct_Style___Sub_Product .toggle-target-container .filter-group__item input[type='checkbox']"
          ).prop('checked', false);
        }
      }
    });

    $(document).on('click', '.collection-filter-form .ct_Category label .breaker_filter-group__checkbox', function () {
      const $form = $(this).closest('.collection-filter-form');
      $form.find('.apply_btn.ct_submit').removeAttr('disabled');

      if (!$(this).prop('checked')) {
        const len_check = jQuery(
          ".collection-filter-form:first .ct_Category .toggle-target-container .filter-group__item input[type='checkbox']:checked"
        ).length;

        if (len_check < 1) {
          jQuery(
            ".collection-filter-form .ct_Style___Sub_Product .toggle-target-container .filter-group__item input[type='checkbox']"
          ).prop('checked', false);
        }
      }
    });
  }

  document.addEventListener('click', function (event) {
    const filterApplyBtn = event.target.closest('#CollectionFilterForm .ct_submit_sec, #CollectionFilterForm .ct_submit');
    if (!filterApplyBtn) return;

    event.preventDefault();
    const form = filterApplyBtn.closest('form');
    if (!form) return;

    if (window.jQuery) {
      const $form = jQuery(form);
      $form.data('allowImmediateSubmit', true);
      $form.trigger('submit');
      $form.data('allowImmediateSubmit', false);
    } else if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  function initPlpPlusFilters() {
    if (!window.jQuery) return;
    const $ = window.jQuery;
    let isAjaxInProgress = false;

    function getPriceControls() {
      return {
        $minInput: $('.cc-price-range__input--min').first(),
        $maxInput: $('.cc-price-range__input--max').first(),
        $barActive: $('.cc-price-range__bar-active'),
        $controlMin: $('.cc-price-range__control--min'),
        $controlMax: $('.cc-price-range__control--max'),
        $applyButton: $('.apply_btn'),
      };
    }

    function calculatePosition(value, min, max) {
      return ((value - min) / (max - min)) * 100;
    }

    function updateApplyButtonState($minInput, $maxInput, $applyButton) {
      const minValue = parseInt($minInput.val(), 10);
      const maxValue = parseInt($maxInput.val(), 10);

      if (!isNaN(minValue) && !isNaN(maxValue) && minValue >= 0 && maxValue >= minValue) {
        $applyButton.removeAttr('disabled');
      } else {
        $applyButton.attr('disabled', 'disabled');
      }
    }

    function updateSliderValues(controls, minValue, maxValue, minPriceLimit, maxPriceLimit) {
      minValue = Math.round(minValue);
      maxValue = Math.round(maxValue);

      const minPosition = calculatePosition(minValue, minPriceLimit, maxPriceLimit);
      const maxPosition = calculatePosition(maxValue, minPriceLimit, maxPriceLimit);

      controls.$barActive.css({
        left: `${minPosition}%`,
        right: `${100 - maxPosition}%`
      });
      controls.$controlMin.css('left', `${minPosition}%`).attr('aria-valuenow', minValue);
      controls.$controlMax.css('left', `${maxPosition}%`).attr('aria-valuenow', maxValue);
    }

    function updateRangeSliderValues(controls, minValue, maxValue, minPriceLimit, maxPriceLimit) {
      minValue = Math.round(minValue);
      maxValue = Math.round(maxValue);

      const minPosition = calculatePosition(minValue, minPriceLimit, maxPriceLimit);
      const maxPosition = calculatePosition(maxValue, minPriceLimit, maxPriceLimit);

      controls.$barActive.css({
        left: `${minPosition}%`,
        right: `${100 - maxPosition}%`
      });
      controls.$controlMin.css('left', `${minPosition}%`).attr('aria-valuenow', parseInt(minValue, 10));
      controls.$controlMax.css('left', `${maxPosition}%`).attr('aria-valuenow', parseInt(maxValue, 10));

      controls.$minInput.val(minValue);
      controls.$maxInput.val(maxValue);
    }

    function handleDrag(controls, startX, startValue, isMinControl, minPriceLimit, maxPriceLimit) {
      const sliderWidth = $('.cc-price-range__bar').width();
      const pricePerPixel = (maxPriceLimit - minPriceLimit) / sliderWidth;

      $(window).on('mousemove.ctPlpPlus touchmove.ctPlpPlus', function (e) {
        e.preventDefault();
        const minPriceChange = parseInt(controls.$minInput.val(), 10) || minPriceLimit;
        const maxPriceChange = parseInt(controls.$maxInput.val(), 10) || maxPriceLimit;
        const clientX = e.clientX || e.originalEvent.touches[0].clientX;
        const diffX = clientX - startX;
        let newValue = startValue + diffX * pricePerPixel;

        if (isMinControl) {
          newValue = Math.min(Math.max(minPriceLimit, newValue), maxPriceChange);
          updateRangeSliderValues(controls, newValue, maxPriceChange, minPriceLimit, maxPriceLimit);
        } else {
          newValue = Math.max(Math.min(maxPriceLimit, newValue), minPriceChange);
          updateRangeSliderValues(controls, minPriceChange, newValue, minPriceLimit, maxPriceLimit);
        }
      });

      $(window).on('mouseup.ctPlpPlus touchend.ctPlpPlus', function () {
        $(window).off('mousemove.ctPlpPlus touchmove.ctPlpPlus');
        $(window).off('mouseup.ctPlpPlus touchend.ctPlpPlus');
      });
    }

    function updateSlider() {
      const controls = getPriceControls();
      if (!controls.$minInput.length || !controls.$maxInput.length) return;

      const minPriceLimit = parseInt(controls.$minInput.attr('min'), 10);
      const maxPriceLimit = parseInt(controls.$maxInput.attr('max'), 10);
      const minValue = parseInt(controls.$minInput.val(), 10) || minPriceLimit;
      const maxValue = parseInt(controls.$maxInput.val(), 10) || maxPriceLimit;

      const minPosition = calculatePosition(minValue, minPriceLimit, maxPriceLimit);
      const maxPosition = calculatePosition(maxValue, minPriceLimit, maxPriceLimit);

      controls.$barActive.css({
        left: `${minPosition}%`,
        right: `${100 - maxPosition}%`
      });
      controls.$controlMin.css('left', `${minPosition}%`).attr('aria-valuenow', parseInt(minValue, 10));
      controls.$controlMax.css('left', `${maxPosition}%`).attr('aria-valuenow', parseInt(maxValue, 10));
    }

    function bindPriceRangeControls() {
      const controls = getPriceControls();
      if (!controls.$minInput.length || !controls.$maxInput.length) return;

      const minPriceLimit = parseInt(controls.$minInput.attr('min'), 10);
      const maxPriceLimit = parseInt(controls.$maxInput.attr('max'), 10);

      updateSliderValues(
        controls,
        parseInt(controls.$minInput.val(), 10) || minPriceLimit,
        parseInt(controls.$maxInput.val(), 10) || maxPriceLimit,
        minPriceLimit,
        maxPriceLimit
      );

      controls.$controlMin.off('mousedown.ctPlpPlus touchstart.ctPlpPlus').on('mousedown.ctPlpPlus touchstart.ctPlpPlus', function (e) {
        const startX = e.clientX || e.originalEvent.touches[0].clientX;
        const startValue = parseInt(controls.$minInput.val(), 10) || minPriceLimit;
        handleDrag(controls, startX, startValue, true, minPriceLimit, maxPriceLimit);
        updateApplyButtonState(controls.$minInput, controls.$maxInput, controls.$applyButton);
      });

      controls.$controlMax.off('mousedown.ctPlpPlus touchstart.ctPlpPlus').on('mousedown.ctPlpPlus touchstart.ctPlpPlus', function (e) {
        const startX = e.clientX || e.originalEvent.touches[0].clientX;
        const startValue = parseInt(controls.$maxInput.val(), 10) || maxPriceLimit;
        handleDrag(controls, startX, startValue, false, minPriceLimit, maxPriceLimit);
        updateApplyButtonState(controls.$minInput, controls.$maxInput, controls.$applyButton);
      });

      controls.$minInput.off('input.ctPlpPlus').on('input.ctPlpPlus', function () {
        const minValue = Math.min(Math.max(minPriceLimit, parseInt($(this).val(), 10) || 0), parseInt(controls.$maxInput.val(), 10));
        updateSliderValues(controls, minValue, parseInt(controls.$maxInput.val(), 10), minPriceLimit, maxPriceLimit);
        updateApplyButtonState(controls.$minInput, controls.$maxInput, controls.$applyButton);
      });

      controls.$maxInput.off('input.ctPlpPlus').on('input.ctPlpPlus', function () {
        const maxValue = Math.max(Math.min(maxPriceLimit, parseInt($(this).val(), 10) || maxPriceLimit), parseInt(controls.$minInput.val(), 10));
        updateSliderValues(controls, parseInt(controls.$minInput.val(), 10), maxValue, minPriceLimit, maxPriceLimit);
        updateApplyButtonState(controls.$minInput, controls.$maxInput, controls.$applyButton);
      });
    }

    bindPriceRangeControls();

    $(document).off('click.ctPlpPlus', '.plp_filter_main li').on('click.ctPlpPlus', '.plp_filter_main li', function () {
      if (isAjaxInProgress) return;

      const $radioButton = $(this).find('input[type="radio"]');
      if (!$radioButton.length) {
        return;
      }

      const filterValue = $radioButton.val();
      const query_key = $radioButton.attr('name');

      const urlParams = new URLSearchParams(window.location.search);
      let sortBy = urlParams.get('sort_by');
      if (!sortBy) {
        const activeSortHref = $('#sort-dropdown-options .link-dropdown__link--active').attr('href');
        if (activeSortHref) {
          const activeSortUrl = new URL(activeSortHref, window.location.origin);
          sortBy = activeSortUrl.searchParams.get('sort_by');
        }
      }

      const nextUrl = new URL(window.location.href);
      const nextParams = nextUrl.searchParams;
      nextParams.delete('page');

      nextParams.delete(query_key);
      if (filterValue) {
        nextParams.append(query_key, filterValue);
      }
      if (sortBy) {
        nextParams.set('sort_by', sortBy);
      }

      const queryString = nextParams.toString();
      const filterURL = `${nextUrl.pathname}${queryString ? `?${queryString}` : ''}`;

      isAjaxInProgress = true;

      if (typeof window.showLoader === 'function') {
        window.showLoader();
      }

      $.ajax({
        url: filterURL,
        type: 'GET',
        dataType: 'html',
        success: function (response) {
          const PLPFilter_apply_clevertap = {
            'Event properties': filterValue
          };
          if (window.clevertap?.event?.push) {
            clevertap.event.push('PLP+ Filter Applied', PLPFilter_apply_clevertap);
          }
          history.replaceState(null, '', filterURL);
          const filteredProducts = $(response).find('.product-list');
          const side_filter = $(response).find('.filter-container');
          const total_item_count = $(response).find('.CT_fil_utility-bar__centre');
          const plp_listing_name = $(response).find('.plp_filter_main');
          const mobile_header = $(response).find('.ct_header');
          const filter_toggle_btn = $(response).find('.ct_filter-toggle-btn');
          const sortby_Value = $(response).find('#sort-dropdown-options');

          if (filteredProducts.length > 0) {
            $('.product-list').html(filteredProducts.html());
            $('.filter-container').html(side_filter.html());
            $('.CT-main-collection-listing').show();
            $('.CT_fil_utility-bar__centre').html(total_item_count.html());
            $('.plp_filter_main').html(plp_listing_name.html());
            $('.ct_header').html(mobile_header);
            if (filter_toggle_btn.length) {
              $('.ct_filter-toggle-btn').replaceWith(filter_toggle_btn);
            }
            $('#sort-dropdown-options').replaceWith(sortby_Value);
            const $appliedFilters = $('.CT-main-collection-listing .ct_filter_apply');
            if ($appliedFilters.find('.filter-group__applied-item').length) {
              $appliedFilters.show();
            } else {
              $appliedFilters.hide();
            }
            if (typeof window.checkVisibilityAndCallAPI === 'function') {
              window.checkVisibilityAndCallAPI();
            }

            const pagination = $(response).find('#infinite-scroll-pagination').first();
            if (pagination.length > 0) {
              $('#infinite-scroll-pagination').html(pagination.html());
              $('#infinite-scroll-pagination').not(':first').remove();
            }
            if (typeof Ajaxinate === 'function') {
              new Ajaxinate({
                container: '#infinite-scroll-loop',
                pagination: '#infinite-scroll-pagination',
                loadingText:
                  '<center><img src="//cdn.shopify.com/s/files/1/0796/1959/files/loading.gif?v=1652268937" loading="lazy"></center>',
              });
            }
          }
        },
        complete: function () {
          isAjaxInProgress = false;
          $('.CT-main-collection-listing').show();
          updateSlider();
          bindPriceRangeControls();
          if (typeof window.updateHeaderStickyForScrollState === 'function') {
            window.updateHeaderStickyForScrollState();
          }
          if (typeof window.closeLoader === 'function') {
            window.closeLoader();
          }
        }
      });

      $radioButton.prop('checked', true);
    });

    $(document).off('click.ctPlpPlus', '#infinite-scroll-pagination a');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlpPlusFilters);
  } else {
    initPlpPlusFilters();
  }
})();
